import React from 'react';
import {connect} from "react-redux";

import StoreEntry from "./StoreEntry";
import CreateStoreModal from "./CreateStoreModal";

import {
    updateStoreSearchQuery,
    getStores,
    changeReplenishmentStrategy,
    updateStoreGln,
    assignStoreToRetailer,
    fetchStoresAndRetailers,
    setStoreForDelivery,
    updateStoreAddress,
    createNewStore
} from './reducer';

import SearchField from '../components/SearchField';

export class StoreManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            storeModalVisible: false
        };
        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.showStoreModal = this.showStoreModal.bind(this);
        this.hideStoreModal = this.hideStoreModal.bind(this);
        this.createNewStore = this.createNewStore.bind(this);
    }

    handleQueryChange(query) {
        this.props.updateStoreSearchQuery(query);
    }

    showStoreModal() {
        this.setState({storeModalVisible: true});
    }

    hideStoreModal() {
        this.setState({storeModalVisible: false});
    }

    createNewStore(store) {
        this.props.createNewStore(store);
        this.hideStoreModal();
    }

    componentDidMount() {
        this.props.fetchStoresAndRetailers();
    }

    render() {
        return (
                <div className="animated fadeIn" style={{fontSize: 'small'}}>
                    <CreateStoreModal retailers={this.props.retailers}
                                      visible={this.state.storeModalVisible}
                                      onSubmit={this.createNewStore}
                                      onCancel={this.hideStoreModal}/>
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Stores</h4>
                            <div className="row">
                                <div className="col-3">
                                    <SearchField className="mb-2 mr-sm-2 mb-sm-0"
                                                 value={this.props.searchQuery}
                                                 onCommit={this.handleQueryChange}/>
                                </div>
                                <div className="col-9">
                                    <button type="button" className="btn btn-light float-right"
                                            onClick={this.showStoreModal}>
                                        <i className="fa fa-plus-circle"/>&nbsp;neuer Store
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <table className="table table-striped">
                                        <thead>
                                        <tr>
                                            <th>Händler&nbsp;<i className="fa fa-edit"/></th>
                                            <th>Store-GLN&nbsp;<i className="fa fa-edit"/></th>
                                            <th>Straße&nbsp;<i className="fa fa-edit"/></th>
                                            <th>PLZ&nbsp;<i className="fa fa-edit"/></th>
                                            <th>Ort&nbsp;<i className="fa fa-edit"/></th>
                                            <th>Verband</th>
                                            <th>abweichende Lieferanschrift&nbsp;<i className="fa fa-edit"/></th>
                                            <th>Nachschub-Auslöser&nbsp;<i className="fa fa-edit"/></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.props.stores.map((store) => <StoreEntry store={store}
                                                                                      key={store.gln}
                                                                                      retailers={this.props.retailers}
                                                                                      deliveryStores={this.props.stores.filter(
                                                                                              deliveryStoreCandidate => (deliveryStoreCandidate.retailer.gln
                                                                                                      === store.retailer.gln)
                                                                                                      && (deliveryStoreCandidate.gln !== store.gln))}
                                                                                      changeReplenishmentStrategy={this.props.changeReplenishmentStrategy}
                                                                                      updateStoreGln={this.props.updateStoreGln}
                                                                                      setStoreForDelivery={this.props.setStoreForDelivery}
                                                                                      assignStoreToRetailer={this.props.assignStoreToRetailer}
                                                                                      updateStoreAddress={this.props.updateStoreAddress}
                                        />)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        stores: state.retailer.get('stores') ? getStores(state.retailer).toJS() : [],
        retailers: state.retailer.get('retailers').toJS(),
        searchQuery: state.retailer.get('storeSearchQuery')
    };
}

const ConnectedStoreManager =
        connect(mapStateToProps, {
            updateStoreSearchQuery,
            changeReplenishmentStrategy,
            updateStoreGln,
            fetchStoresAndRetailers,
            assignStoreToRetailer,
            setStoreForDelivery,
            updateStoreAddress,
            createNewStore
        })(StoreManager);

export default ConnectedStoreManager;



// WEBPACK FOOTER //
// ./src/admin/retailer/StoreManager.js